import { defineNuxtPlugin } from '#app';

// This Nuxt plugin performs the following actions:
// 1. Creates and mounts a component in the DOM to display a loading state.
// 2. Removes the loading component after the page loading is completed.

export default defineNuxtPlugin((nuxtApp) => {
    // Check if the 'document' object and its 'body' property exist.
    if (document && document.body) {
        // Create a 'div' element to display the loading component.
        const loaderHtmlComponent = document.createElement('div');
        // Insert the HTML code for the loading component, specified in the plugin options.
        loaderHtmlComponent.innerHTML = `<!doctype html>
<html lang="en">
    <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <style>
            * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
                outline: 0;
            }

            html,
            body {
                height: 100vh;
                width: 100vh;
                overflow: hidden;
            }

            body {
                overflow: hidden;
                background-color: #262626;
                background-repeat: no-repeat;
                background-position: center center;
                background-attachment: fixed;
                -webkit-background-size: cover;
                background-size: cover;
            }

            .boot-loader {
                width: 100%;
                height: 100%;
                position: fixed;
                z-index: 1000;
                background: #262626;
            }

            .boot-loader__wrapper {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 100%;
                min-height: 100%;
                max-width: 1320px;
                margin: 0 auto;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            .boot-loader__wrapper > * {
                flex: 0 0 50%;
                max-width: 50%;
            }

            .boot-loader__wrapper--image {
                width: 100%;
            }

            .boot-loader__wrapper--line {
                width: 100%;
                margin: 6rem 0 0;
            }

            .boot-preloader {
                width: 100%;
                height: 10px;
                border-radius: 5px;
                background-color: rgba(255, 255, 255, 0.22);
                position: relative;
                overflow: hidden;
            }

            .boot-preloader--line {
                height: 100%;
                background-color: #6bd7fd;
                position: absolute;
                top: 0;
                left: 0;
                animation: loading 3s linear infinite;
            }

            @keyframes loading {
                0% {
                    width: 0;
                }
                100% {
                    width: 100%;
                }
            }
        </style>
    </head>
    <body>
        <div class="boot-loader">
            <div class="boot-loader__wrapper">
                <div class="boot-loader__wrapper--image">
                    <svg role="img" viewBox="-0.41 8.407 255.58 46.105" xmlns="http://www.w3.org/2000/svg">
                        <mask id="a" width="1091" height="728" x="0" y="0" maskUnits="userSpaceOnUse">
                            <path fill="#fff" d="M0 728h1091V.00006H0V728z" />
                        </mask>
                        <mask id="b" width="1091" height="728" x="0" y="0" maskUnits="userSpaceOnUse">
                            <path fill="#fff" d="M0 728h1091V0H0v728z" />
                        </mask>
                        <mask id="c" width="1091" height="728" x="0" y="0" maskUnits="userSpaceOnUse">
                            <path fill="#fff" d="M0 728h1091V0H0v728z" />
                        </mask>
                        <g mask="url(#a)" transform="matrix(1.039046, 0, 0, 1.039046, -4.976538, -0.481084)">
                            <path
                                fill="#4DC5EA"
                                d="M148.78818 23.15463h-15.096v-14.246h-5.746v14.246h-15.096v5.423h15.096v14.246h5.746v-14.246h15.096v-5.423zm-44.299 2.769c-.31-.276-.651-.539-1.011-.794-.035-.024-.067-.051-.102-.075-.087-.059-.171-.119-.259-.177-.021-.013-.043-.029-.065-.042-1.445-.934-3.224-1.684-5.225-2.188l-.061-.013c-.248-.061-.491-.116-.736-.172-.658-.154-1.309-.3-1.947-.435-.12-.026-.243-.053-.364-.079-.014-.003-.028-.006-.041-.008-3.521-.753-6.301-1.347-6.301-2.908 0-1.272 1.448-2.297 3.522-2.495 2.264-.209 4.391.443 6.517 1.998.31.269 1.059.934 1.364 1.248.001.001.004.002.004.002.028.027.066.044.108.044.028 0 .051-.009.074-.021h.004l4.881-3.621.775-.574.435-.324s.001-.002.001-.003c.042-.025.07-.066.07-.115 0-.032-.013-.059-.031-.082l-.001-.003c-.001-.002-.004-.005-.004-.006-.005-.003-.008-.008-.012-.011-.421-.495-.943-1.01-1.358-1.416-.155-.154-.295-.291-.404-.402-1.165-1.222-2.646-2.229-4.327-2.981-.506-.226-1.028-.433-1.567-.611-1.819-.603-3.81-.927-5.851-.927-.075 0-.15.001-.224.004-.058.002-.114.003-.171.004-.236.002-.469.007-.699.016l-.05.003c-.237.01-.474.03-.712.05-4.297.474-7.939 2.451-9.946 5.191-.64.874-1.114 1.824-1.389 2.828-.084.359-.151.725-.202 1.099-.002.028-.008.054-.012.082-.002.026-.005.05-.009.076-.05.324-.084.653-.084.986 0 .818.156 1.613.447 2.374.415 1.082 1.111 2.094 2.028 3.009 1.491 1.486 3.576 2.712 6.05 3.54l1.119.332c.595.17 2.82.61 3.757.829 1.318.309 2.546.66 3.548 1.044 1.433.549 2.387 1.226 2.387 2.278 0 .23-.05.454-.142.666-.055.125-.105.236-.188.353-.043.069-.096.138-.152.203-.211.321-.584.596-1.048.804l.062-.025c-1.414.672-3.526.963-5.821.689-1.244-.148-2.392-.444-3.373-.84-1.265-.469-2.631-1.319-3.871-2.486-.075-.072-.151-.144-.223-.218-.026-.027-.064-.044-.105-.044-.036 0-.068.012-.092.033l-4.748 3.522-1.107.822-.049.036-.004.003-.001.003c-.042.025-.07.068-.07.117 0 .033.014.063.033.087l.003.006c.183.218.372.429.565.639 1.598 1.739 3.521 3.145 5.649 4.17 2.42 1.167 5.108 1.837 7.893 1.908.131.002.262.006.394.007.075 0 .152.001.227.001 5.982-.013 11.165-2.314 13.754-5.677 1.121-1.458 1.759-3.111 1.759-4.867 0-2.438-1.222-4.679-3.271-6.466zm-41.246-16.472c-.921-.273-1.871-.476-2.84-.601-.784-.101-1.579-.158-2.382-.158-9.71 0-17.611 7.523-17.611 16.769 0 2.441.57 4.78 1.578 6.907.559 1.177 1.253 2.286 2.062 3.312 1.839 2.382 4.32 4.292 7.208 5.507.061.027.12.052.181.077.096.04.194.079.292.116 2.07.819 4.321 1.276 6.661 1.276.029 0 .058-.003.086-.003.033 0 .064.003.095.003 3.72 0 7.178-1.068 10.044-2.894 1.526-.972 2.88-2.161 4.022-3.517v-.001c.014-.015.024-.036.024-.058 0-.03-.018-.056-.044-.071l-6-4.399c-.028-.028-.066-.046-.11-.046-.043 0-.08.018-.108.046l-.002.001c-.506.419-2.838 2.205-6.097 2.586-.392.034-.804.06-1.239.071-1.401-.002-2.598-.198-3.624-.52-1.722-.602-3.386-1.696-4.514-3.179-.597-.816-.917-1.551-1.06-1.943-.035-.098-.069-.197-.099-.297h24.91c.067 0 .125-.045.137-.109.938-5.312-.368-10.268-3.676-13.954-2.097-2.336-4.841-4.02-7.894-4.921zm-12.948 11.875c1.568-2.698 4.508-4.471 7.726-4.471 3.22 0 6.161 1.773 7.729 4.471h-15.455zm-11.696-11.655l-8.768-.011s-.004-.001-.006-.001c-.114 0-.208.079-.224.182-1.331 7.628-3.092 13.694-5.378 18.532-.663 1.399-1.386 2.721-2.15 3.928l-.268.423-.276-.418c-1.168-1.77-2.236-3.686-3.174-5.697-.753-1.613-1.428-3.299-2.009-5.014-1.257-3.713-2.1-7.634-2.51-11.661l-.002-.001c-.017-.154-.153-.274-.322-.274h-8.413c-.18 0-.325.137-.325.307 0 .024.004.049.01.072.085.943.192 1.892.32 2.829 1.228 9.021 4.391 17.495 9.147 24.505.403.595 1.179 1.678 1.217 1.73l.169.236-.237.172c-2.695 1.97-5.699 3.322-8.927 4.016l-.086.02c-.578.122-1.17.224-1.766.303l-.001.001c-.024.004-.04.021-.04.044v8.28c0 .033.025.059.059.059 5.151-.323 10.041-1.913 14.155-4.606.351-.213.656-.406.941-.594.495-.328 1-.689 1.545-1.101 2.382-1.805 4.577-4.029 6.525-6.608 5.288-7.002 8.994-16.891 11.019-29.401.002-.011.003-.024.003-.037 0-.118-.102-.215-.228-.215z"
                            />
                        </g>
                        <g mask="url(#b)" transform="matrix(1.039046, 0, 0, 1.039046, -4.976538, -0.481084)">
                            <path
                                fill="#4DC5EA"
                                d="M250.32818 39.00163c0 2.17-1.864 3.928-4.163 3.928-2.299 0-4.162-1.758-4.162-3.928 0-2.169 1.863-3.928 4.162-3.928s4.163 1.759 4.163 3.928z"
                            />
                        </g>
                        <g mask="url(#c)" transform="matrix(1.039046, 0, 0, 1.039046, -4.976538, -0.481084)">
                            <path
                                fill="#fff"
                                stroke="#fff"
                                stroke-width=".667"
                                d="M189.68818 8.93463h-6.294l-10.848 16.903-10.798-16.903h-6.346v33.804h5.886v-24.146l10.899 17.048h.716l10.9-16.999v24.097h5.885v-33.804zm7.163 33.804h5.885v-33.804h-5.885v33.804zm33.467 0h6.447l-8.136-13.134c4.196-1.594 7.113-5.457 7.113-9.804 0-6.036-5.117-10.866-11.514-10.866h-14.327v33.804h5.885v-12.314h6.959l7.573 12.314zm-14.532-28.588h8.442c3.122 0 5.63 2.463 5.63 5.65 0 3.138-2.508 5.65-5.63 5.65h-8.442v-11.3z"
                            />
                        </g>
                    </svg>
                </div>
                <div class="boot-loader__wrapper--line">
                    <div class="boot-preloader">
                        <div class="boot-preloader--line"></div>
                    </div>
                </div>
            </div>
        </div>
    </body>
</html>
`;
        // Insert the loading component at the beginning of the document's body.
        document.body.insertBefore(loaderHtmlComponent, document.body.firstChild);

        function removeHTMLComponent() {
            if (loaderHtmlComponent) {
                // Remove the loading component.
                loaderHtmlComponent.remove();
            }
        }

        // Register the 'page:finish' hook to perform actions after page loading is complete.
        nuxtApp.hook('page:finish', () => {
            setTimeout(() => {
                // Remove the loading component.
                removeHTMLComponent();
            }, Number(`2000`));
        });

        // Remove element after fatal error occures
        nuxtApp.hook('app:error', () => {
            // Remove the loading component.
            removeHTMLComponent();
        });
    }
});
